<div class="cam">
	<h1 class="cam-title">{{ 'setup.cross-account-one-monitoring.title' | translate }}</h1>

	@if (isLoading) {
		<p class="cam-muted">{{ 'setup.cross-account-one-monitoring.loading' | translate }}</p>
	} @else if (noAccess) {
		<p class="cam-muted">{{ 'setup.cross-account-one-monitoring.no-access' | translate }}</p>
	} @else if (overview) {
		<div class="cam-header">
			<span>{{ 'setup.cross-account-one-monitoring.interval' | translate: { minutes: overview.intervalMinutes } }}</span>
			@if (oldestPassDisplay) {
				<span>{{ 'setup.cross-account-one-monitoring.oldest-pass' | translate: { time: oldestPassDisplay } }}</span>
			}
			@if (overview.staleAccounts.length > 0) {
				<span class="cam-badge cam-badge-warn">{{ 'setup.cross-account-one-monitoring.stale-accounts' | translate: { accounts: staleAccountNames } }}</span>
			}
		</div>

		@if (overview.environments.length === 0) {
			<mat-card class="cam-card">
				<span class="cam-badge cam-badge-ok">{{ 'setup.cross-account-one-monitoring.all-clear' | translate }}</span>
			</mat-card>
		} @else {
			<div class="cam-tiles">
				@for (tile of tiles; track tile.preset) {
					<button type="button" class="cam-tile" [ngClass]="'cam-tile-' + tile.preset" [class.cam-active]="preset === tile.preset" [attr.aria-pressed]="preset === tile.preset" (click)="selectPreset(tile.preset)">
						<span class="cam-tile-title">{{ 'setup.cross-account-one-monitoring.presets.' + tile.preset | translate }}</span>
						<b class="cam-tile-count">{{ tile.counts.errors }}</b>
						<small class="cam-tile-text">{{ 'setup.cross-account-one-monitoring.tiles.' + tile.preset | translate: { tables: tile.counts.tables } }}</small>
					</button>
				}
			</div>

			<mat-card class="cam-card">
				<h2>{{ 'setup.cross-account-one-monitoring.attention.title' | translate }}</h2>
				<div class="cam-incidents">
					@for (line of attentionLines; track line) {
						<div class="cam-incident">
							<div class="cam-incident-what">
								<b>{{ accountNameOf(line.environment) }} · {{ line.environment.environmentName }}</b>
								<span class="cam-muted">{{ 'setup.cross-account-one-monitoring.attention.' + line.type | translate: { count: line.count } }}</span>
								<div class="cam-kinds">
									@if (line.environment.auditStatus; as status) {
										<span class="cam-audit" [ngClass]="'cam-audit-' + auditTone(status)">{{ 'setup.cross-account-one-monitoring.audit-badge' | translate: { status: auditStatusLabel(status) } }}</span>
									}
									<span class="cam-kind" [ngClass]="'cam-kind-' + line.type">{{ 'setup.cross-account-one-monitoring.attention.badge.' + line.type | translate }}</span>
									@for (kind of line.kinds; track kind) {
										<span class="cam-kind" [title]="kind">{{ kindLabel(kind) }}</span>
									}
								</div>
							</div>
							<div class="cam-incident-actions">
								<button mat-stroked-button type="button" (click)="showInList(line)">{{ 'setup.cross-account-one-monitoring.attention.show-in-list' | translate }}</button>
								<a class="cam-iconlink" [href]="line.link" target="_blank" rel="opener" [title]="'setup.cross-account-one-monitoring.open' | translate"><mat-icon svgIcon="acies_launch"></mat-icon></a>
							</div>
						</div>
					}
				</div>
				@if (remainingRetryingTables > 0) {
					<p class="cam-note">{{ 'setup.cross-account-one-monitoring.attention.remaining-retrying' | translate: { count: remainingRetryingTables } }}</p>
				}
			</mat-card>

			<mat-card class="cam-card cam-list">
				<div class="cam-list-head">
					<h2>{{ 'setup.cross-account-one-monitoring.list-title' | translate }}</h2>
					<div class="cam-presets">
						@for (option of presets; track option) {
							<button mat-stroked-button type="button" [class.cam-active]="preset === option" [attr.aria-pressed]="preset === option" (click)="selectPreset(option)">{{ 'setup.cross-account-one-monitoring.presets.' + option | translate }}</button>
						}
					</div>
				</div>

				<app-generictable [tableSource]="tableSource" [tableColumns]="tableColumns" [showPaginator]="false" [rowClass]="rowClass" [expandableDetailTemplate]="noDetail" [rowExpanded]="rowExpanded" (rowExpandToggle)="onRowToggle($event)"></app-generictable>
				<ng-template #noDetail></ng-template>
			</mat-card>
		}
	}
</div>
